import Axios from 'axios';
import { authorizationHeader } from './apiUtils';
import { UpdateVendorData, Vendor } from '../models/misc';

const routes = {
  vendors: '/api/vendors',
  validateNow: '/api/vendors/validate-diamonds',
  downloadLastFile: '/api/diamonds/download-last-file',
};

const getAllVendors = async (): Promise<Vendor[]> => {
  const result = await Axios.get<Vendor[]>(routes.vendors, {
    headers: authorizationHeader(),
  });
  return result.data;
};

const editVendor = async (vendor: UpdateVendorData): Promise<Vendor> => {
  const route = `/api/vendors/${encodeURIComponent(vendor.vendorName)}`;
  const result = await Axios.put<Vendor>(route, vendor, {
    headers: authorizationHeader(),
  });
  return result.data;
};

const validateDiamondsNow = async (): Promise<void> => {
  await Axios.post(routes.validateNow, null, {
    headers: authorizationHeader(),
  });
};

const downloadLastImportedFile = async (vendorName: string): Promise<void> => {
  const url = `${routes.downloadLastFile}?vendorName=${encodeURIComponent(vendorName)}`;

  const response = await Axios.get(url, {
    headers: authorizationHeader(),
    responseType: 'blob',
  });

  const blob = response.data;
  const fileName = `${vendorName}_last_imported.csv`;

  const downloadUrl = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = fileName;

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
};

export { getAllVendors, editVendor, validateDiamondsNow, downloadLastImportedFile };
